export function MoneyFormattedUtils(
  amount: number | string,
  language?: string,
  options: Intl.NumberFormatOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }
): string {
  if (!language) {
    language = 'es-ES';
  }

  return Number.parseFloat(amount as string).toLocaleString(language, options);
}

export function formatCurrency(
  value: number,
  currencyCode: string,
  locale: string = 'es-CO'
) {
  if (!value || !currencyCode) {
    return '';
  }
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return formatter.format(value);
}
